import { render } from "./RecipeForm.vue?vue&type=template&id=281271dc&scoped=true"
import script from "./RecipeForm.vue?vue&type=script&lang=js"
export * from "./RecipeForm.vue?vue&type=script&lang=js"

import "./RecipeForm.vue?vue&type=style&index=0&id=281271dc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-281271dc"

export default script